import type { RcFile } from 'antd/es/upload/interface';

export const resizeImage = (
  file: RcFile | File,
  maxSize = 800,
  quality = 0.7,
): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let { width, height } = img;

        if (width > height) {
          if (width > maxSize) {
            height = Math.round((height * maxSize) / width);
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width = Math.round((width * maxSize) / height);
            height = maxSize;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          return reject(new Error('Failed to get canvas context'));
        }
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL(file.type, quality));
      };
      img.onerror = reject;
    };
    reader.onerror = reject;
  });

export async function resizeImageToFile(
  file: RcFile | File,
  maxSize = 800,
  quality = 0.7,
): Promise<File> {
  const dataUrl = await resizeImage(file, maxSize, quality);
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], file.name, { type: file.type || blob.type });
}
